import React, { useState } from 'react';
import { Users, ChevronRight, Plus, X, User, Calendar, CheckSquare } from 'lucide-react';
import { Link } from 'react-router-dom';
export function AddCommittee() {
  const [committeeType, setCommitteeType] = useState<'standard' | 'parent' | 'sub'>('standard');
  const [parentCommittee, setParentCommittee] = useState('');
  const [members, setMembers] = useState<{
    id: number;
    name: string;
    role: string;
    department: string;
  }[]>([]);
  const departments = ['المالية', 'الموارد البشرية', 'تقنية المعلومات', 'العمليات', 'التسويق', 'الشؤون القانونية', 'البحث والتطوير', 'خدمة العملاء', 'المبيعات', 'المشتريات'];
  const roles = ['رئيس اللجنة', 'أمين السر', 'عضو'];
  const parentCommittees = [{
    id: 1,
    name: 'لجنة الحوكمة'
  }, {
    id: 2,
    name: 'اللجنة التنفيذية'
  }, {
    id: 3,
    name: 'لجنة التدقيق'
  }];
  const availableUsers = [{
    id: 1,
    name: 'محمد الهاشمي',
    department: 'المالية'
  }, {
    id: 2,
    name: 'عائشة المنصوري',
    department: 'الموارد البشرية'
  }, {
    id: 3,
    name: 'عمر الشامسي',
    department: 'تقنية المعلومات'
  }, {
    id: 4,
    name: 'فاطمة الزعابي',
    department: 'العمليات'
  }, {
    id: 5,
    name: 'أحمد الظاهري',
    department: 'المالية'
  }, {
    id: 6,
    name: 'نورة السويدي',
    department: 'التسويق'
  }, {
    id: 7,
    name: 'خالد المزروعي',
    department: 'الشؤون القانونية'
  }, {
    id: 8,
    name: 'مريم النعيمي',
    department: 'الموارد البشرية'
  }];
  const addMember = (user: {
    id: number;
    name: string;
    department: string;
  }, role: string) => {
    const newMember = {
      id: user.id,
      name: user.name,
      role: role,
      department: user.department
    };
    setMembers([...members, newMember]);
  };
  const removeMember = (id: number) => {
    setMembers(members.filter(member => member.id !== id));
  };
  // Filter out users who are already added as members
  const filteredUsers = availableUsers.filter(user => !members.some(member => member.id === user.id));
  return <div dir="rtl" data-id="element-123">
      <div className="flex items-center mb-6" data-id="element-124">
        <Link to="/committees" className="flex items-center text-gray-600 hover:text-gray-900 ml-4" data-id="element-125">
          <ChevronRight size={20} className="ml-1" data-id="element-126" />
          العودة إلى اللجان
        </Link>
        <h1 className="text-2xl font-bold" data-id="element-127">إنشاء لجنة جديدة</h1>
      </div>
      <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-128">
        <form data-id="element-129">
          <div className="space-y-6" data-id="element-130">
            {/* Committee Type Selection */}
            <div data-id="element-131">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-132">
                نوع اللجنة <span className="text-red-500" data-id="element-133">*</span>
              </label>
              <div className="flex space-x-4" data-id="element-134">
                <label className="flex items-center" data-id="element-135">
                  <input type="radio" name="committeeType" value="standard" checked={committeeType === 'standard'} onChange={() => setCommitteeType('standard')} className="ml-2" data-id="element-136" />
                  لجنة قياسية
                </label>
                <label className="flex items-center mr-4" data-id="element-137">
                  <input type="radio" name="committeeType" value="parent" checked={committeeType === 'parent'} onChange={() => setCommitteeType('parent')} className="ml-2" data-id="element-138" />
                  لجنة رئيسية
                </label>
                <label className="flex items-center mr-4" data-id="element-139">
                  <input type="radio" name="committeeType" value="sub" checked={committeeType === 'sub'} onChange={() => setCommitteeType('sub')} className="ml-2" data-id="element-140" />
                  لجنة فرعية
                </label>
              </div>
            </div>
            {/* Parent Committee Selection (for sub-committees) */}
            {committeeType === 'sub' && <div data-id="element-141">
                <label htmlFor="parentCommittee" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-142">
                  اللجنة الرئيسية <span className="text-red-500" data-id="element-143">*</span>
                </label>
                <select id="parentCommittee" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" value={parentCommittee} onChange={e => setParentCommittee(e.target.value)} required data-id="element-144">
                  <option value="" data-id="element-145">اختر اللجنة الرئيسية</option>
                  {parentCommittees.map(committee => <option key={committee.id} value={committee.id.toString()} data-id="element-146">
                      {committee.name}
                    </option>)}
                </select>
              </div>}
            {/* Committee Name */}
            <div data-id="element-147">
              <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-148">
                اسم اللجنة <span className="text-red-500" data-id="element-149">*</span>
              </label>
              <input type="text" id="name" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" placeholder={committeeType === 'sub' ? 'أدخل اسم الفريق/اللجنة الفرعية' : 'أدخل اسم اللجنة'} required data-id="element-150" />
            </div>
            {/* Committee Description */}
            <div data-id="element-151">
              <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-152">
                الوصف <span className="text-red-500" data-id="element-153">*</span>
              </label>
              <textarea id="description" rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" placeholder={committeeType === 'sub' ? 'أدخل وصف وأهداف الفريق/اللجنة الفرعية' : 'أدخل وصف وأهداف اللجنة'} required data-id="element-154"></textarea>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-155">
              {/* Start Date */}
              <div data-id="element-156">
                <label htmlFor="startDate" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-157">
                  تاريخ البدء <span className="text-red-500" data-id="element-158">*</span>
                </label>
                <div className="relative" data-id="element-159">
                  <input type="date" id="startDate" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" required data-id="element-160" />
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-161">
                    <Calendar size={18} className="text-gray-400" data-id="element-162" />
                  </div>
                </div>
              </div>
              {/* End Date */}
              <div data-id="element-163">
                <label htmlFor="endDate" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-164">
                  تاريخ الانتهاء
                </label>
                <div className="relative" data-id="element-165">
                  <input type="date" id="endDate" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" data-id="element-166" />
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-167">
                    <Calendar size={18} className="text-gray-400" data-id="element-168" />
                  </div>
                </div>
              </div>
              {/* Meeting Frequency */}
              <div data-id="element-169">
                <label htmlFor="frequency" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-170">
                  تكرار الاجتماعات
                </label>
                <select id="frequency" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" data-id="element-171">
                  <option value="" data-id="element-172">اختر التكرار</option>
                  <option value="weekly" data-id="element-173">أسبوعي</option>
                  <option value="biweekly" data-id="element-174">كل أسبوعين</option>
                  <option value="monthly" data-id="element-175">شهري</option>
                  <option value="quarterly" data-id="element-176">ربع سنوي</option>
                  <option value="asNeeded" data-id="element-177">عند الحاجة</option>
                </select>
              </div>
              {/* Status */}
              <div data-id="element-178">
                <label htmlFor="status" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-179">
                  الحالة <span className="text-red-500" data-id="element-180">*</span>
                </label>
                <select id="status" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" required data-id="element-181">
                  <option value="" data-id="element-182">اختر الحالة</option>
                  <option value="active" data-id="element-183">نشطة</option>
                  <option value="planning" data-id="element-184">قيد التخطيط</option>
                  <option value="onHold" data-id="element-185">معلقة</option>
                  <option value="completed" data-id="element-186">مكتملة</option>
                </select>
              </div>
            </div>
            {/* Members Section */}
            <div data-id="element-187">
              <h3 className="text-lg font-medium mb-3" data-id="element-188">أعضاء اللجنة</h3>
              {/* Current Members */}
              {members.length > 0 && <div className="mb-4" data-id="element-189">
                  <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-190">
                    الأعضاء الحاليون
                  </h4>
                  <div className="overflow-x-auto" data-id="element-191">
                    <table className="w-full" data-id="element-192">
                      <thead data-id="element-193">
                        <tr className="bg-gray-50" data-id="element-194">
                          <th className="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-195">
                            الاسم
                          </th>
                          <th className="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-196">
                            الدور
                          </th>
                          <th className="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-197">
                            القسم
                          </th>
                          <th className="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-198">
                            الإجراءات
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200" data-id="element-199">
                        {members.map(member => <tr key={member.id} data-id="element-200">
                            <td className="px-4 py-2 whitespace-nowrap" data-id="element-201">
                              <div className="flex items-center" data-id="element-202">
                                <div className="h-8 w-8 bg-gray-700 rounded-full flex items-center justify-center text-white font-medium ml-3" data-id="element-203">
                                  {member.name.charAt(0)}
                                </div>
                                <span className="font-medium" data-id="element-204">
                                  {member.name}
                                </span>
                              </div>
                            </td>
                            <td className="px-4 py-2 whitespace-nowrap" data-id="element-205">
                              <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${member.role === 'رئيس اللجنة' ? 'bg-blue-100 text-blue-800' : member.role === 'أمين السر' ? 'bg-purple-100 text-purple-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-206">
                                {member.role}
                              </span>
                            </td>
                            <td className="px-4 py-2 whitespace-nowrap" data-id="element-207">
                              {member.department}
                            </td>
                            <td className="px-4 py-2 whitespace-nowrap" data-id="element-208">
                              <button type="button" onClick={() => removeMember(member.id)} className="text-red-500 hover:text-red-700" data-id="element-209">
                                <X size={16} data-id="element-210" />
                              </button>
                            </td>
                          </tr>)}
                      </tbody>
                    </table>
                  </div>
                </div>}
              {/* Add Member Form */}
              <div className="bg-gray-50 p-4 rounded-lg" data-id="element-211">
                <h4 className="text-sm font-medium text-gray-700 mb-3" data-id="element-212">
                  إضافة عضو
                </h4>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-213">
                  {/* Member Selection */}
                  <div data-id="element-214">
                    <label htmlFor="member" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-215">
                      اختر العضو
                    </label>
                    <select id="member" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" data-id="element-216">
                      <option value="" data-id="element-217">اختر مستخدم</option>
                      {filteredUsers.map(user => <option key={user.id} value={user.id} data-id="element-218">
                          {user.name} ({user.department})
                        </option>)}
                    </select>
                  </div>
                  {/* Role Selection */}
                  <div data-id="element-219">
                    <label htmlFor="role" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-220">
                      الدور
                    </label>
                    <select id="role" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" data-id="element-221">
                      <option value="" data-id="element-222">اختر الدور</option>
                      {roles.map((role, index) => <option key={index} value={role} data-id="element-223">
                          {role}
                        </option>)}
                    </select>
                  </div>
                  {/* Add Button */}
                  <div className="flex items-end" data-id="element-224">
                    <button type="button" className="w-full px-3 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors flex items-center justify-center" onClick={() => {
                    const selectElement = document.getElementById('member') as HTMLSelectElement;
                    const selectedUserId = Number(selectElement.value);
                    const roleElement = document.getElementById('role') as HTMLSelectElement;
                    const selectedRole = roleElement.value;
                    if (selectedUserId && selectedRole) {
                      const selectedUser = availableUsers.find(u => u.id === selectedUserId);
                      if (selectedUser) {
                        addMember(selectedUser, selectedRole);
                        // Reset selections
                        selectElement.value = '';
                        roleElement.value = '';
                      }
                    }
                  }} data-id="element-225">
                      <Plus size={18} className="ml-1" data-id="element-226" />
                      إضافة عضو
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* Submit Buttons */}
            <div className="flex justify-end space-x-3 pt-4" data-id="element-227">
              <Link to="/committees" className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors mr-3" data-id="element-228">
                إلغاء
              </Link>
              <button type="submit" className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors" data-id="element-229">
                <CheckSquare size={18} className="inline ml-2" data-id="element-230" />
                إنشاء {committeeType === 'sub' ? 'لجنة فرعية' : 'لجنة'}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>;
}